import React from 'react';
import { LockKeyhole } from 'lucide-react';

const CompactSubscriptionModal = (props) => {
    let imgPath = props.app.config.assetsUrl + "/" + props.app.config.imageUrl,
        modalIcon = `${imgPath}/misc/pause-solid-full.svg`;

    if (props.context !== undefined && props.context === 'welcomeback') {
        modalIcon = `${imgPath}/misc/hand-wave-solid-full.svg`;
    }

    /*
    <div className="frame-1">
            <section
                className="pro-blocks-empty-section-1"
                aria-labelledby="empty-section-title">
                <div className="pro-blocks-empty-content">
                    <button
                        type="button"
                        className="dialog-close"
                        aria-label="Close"
                        id="dialog-close"
                        onClick={props.closeAction}>
                        <span className="dialog-close__icon" aria-hidden="true">
                            <img src={`${imgPath}/misc/close-icon.svg`} width="12" height="12" alt="" />
                        </span>
                    </button>
                    <div className="figma-icon-wrapper" aria-hidden="true">
                        <div className="icon-placeholder">
                            <div className="icon-placeholder-inner">
                                <div className="pause-1">
                                    <div className="vector">
                                        <img src={modalIcon} width="24" height="24" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex-vertical">
                        <h1 id="empty-section-title" className="flex-vertical__title">
                            {props.headline}
                        </h1>
                        <p className="flex-vertical__description">
                            {props.mainCopy}
                        </p>
                    </div>

                    <div className="empty-content-flex">
                        <button type="button" className="figma-button button--primary" onClick={props.confirmAction}>
                            <span className="button__label">{props.confirmLabel}</span>
                        </button>
                        <button type="button" className="figma-button button--outline" onClick={props.cancelAction}>
                            <span className="button__label">{props.cancelLabel}</span>
                        </button>
                    </div>
                </div>
                */

    return (
        <div className="frame-1">
            <section
                className="pro-blocks-empty-section-1"
                aria-labelledby="empty-section-title"
            >
                <div className="pro-blocks-empty-content">
                    <button
                        type="button"
                        className="dialog-close"
                        aria-label="Close"
                        id="dialog-close"
                        onClick={props.closeAction}
                    >
                        <span className="dialog-close__icon" aria-hidden="true">
                            <img src={`${imgPath}/misc/close-icon.svg`} width="12" height="12" alt="" />
                        </span>
                    </button>

                    <div className="figma-icon-wrapper" aria-hidden="true">
                        <svg
                            className="figma-icon"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <LockKeyhole/>
                        </svg>
                    </div>

                    <div className="flex-vertical">
                        <h1 id="empty-section-title" className="flex-vertical__title">
                            {props.headline}
                        </h1>
                        <p className="flex-vertical__description">
                            {props.mainCopy}
                        </p>
                    </div>

                    <div className="features">
                        <p className="features__header">Free plan limits</p>
                        <div className="features__item">
                            <span className="features__label">Monthly posts</span>
                            <span className="features__value">10 per profile</span>
                        </div>
                        <div className="features__item">
                            <span className="features__label">Social profiles</span>
                            <span className="features__value">3 max / 1 per network</span>
                        </div>
                        <div className="features__item">
                            <span className="features__label">Content checks</span>
                            <span className="features__value">Every 6 hours</span>
                        </div>
                    </div>

                    <div className="empty-content-flex">
                        <button type="button" className="figma-button button--primary" onClick={props.confirmAction}>
                            <span className="button__label">{props.confirmLabel}</span>
                        </button>
                        <button type="button" className="figma-button button--outline" onClick={props.cancelAction}>
                            <span className="button__label">{props.cancelLabel}</span>
                        </button>
                    </div>
                </div>
            </section>
        </div>
    )
};

export default CompactSubscriptionModal;
